import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { reduxForm, change } from 'redux-form';
import Button from 'react-bootstrap/lib/Button';
import cx from 'classnames';

import PlaceGeoSuggest from '../../Common/GeoSuggest/PlaceGeoSuggest';
import detectMobileBrowsers from '../../../helpers/detectMobileBrowsers';
import messages from '../../../locale/messages';
import history from '../../../core/history';
import { searchFormSuggestSelect, changeSearchForm } from '../../../helpers/GeoSuggest/updateSearchForm';
import { setPersonalizedValues } from '../../../actions/personalized';

import searchIcon from '/public/SiteIcons/searchIconHome.svg';

import bt from '../../commonStyle.css';
import s from './LocationSearchForm.css';

const LocationSearchForm = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const personalized = useSelector((state) => state?.personalized);
  const settingsData = useSelector((state) => state?.viewListing?.settingsData);
  const listingFields = useSelector((state) => state?.listingFields?.data);

  const [mobileDevice, setMobileDevice] = useState(false);
  const [roomType, setRoomType] = useState(null);

  useEffect(() => {
    if (detectMobileBrowsers.isMobile()) {
      setMobileDevice(true);
    }
  }, []);

  useEffect(() => {
    if (listingFields !== undefined) {
      setRoomType(listingFields.roomType);
    }
  }, [listingFields]);

  const handleClick = () => {
    let uri = '/s?';
    if (personalized?.chosen != null) {
      uri += `&address=${personalized.location}&chosen=${personalized.chosen}`;
    } else if (personalized?.location != null) {
      uri += `&address=${personalized.location}`;
    }
    history.push(encodeURI(uri));
  };

  const onSuggestSelect = (data, value) => {
    searchFormSuggestSelect({ data, setPersonalizedValues: (values) => dispatch(setPersonalizedValues(values)), value, change: (field, val) => dispatch(change('SearchForm', field, val)) });
  };

  const onChange = async (value) => {
    if (value === '') {
      changeSearchForm({ setPersonalizedValues: (values) => dispatch(setPersonalizedValues(values)), change: (...args) => dispatch(change(...args)) });
    }
  };

  return (
    <form>
      <div className={cx(s.locationSearchFormContainer)}>
        <PlaceGeoSuggest
          placeholder={intl.formatMessage(messages.homeWhere)}
          className={cx(s.locationSearchInput, 'rtlLocationSearchInput')}
          initialValue={personalized?.location}
          onChange={onChange}
          onSuggestSelect={onSuggestSelect}
          id={'locationSearch'}
          containerClass={cx(s.searchInputContainer, 'layoutOneGeoSuggest')}
        />
        <div className={cx(s.searchBtnContainer, 'searchBtnContainerAr')}>
          <Button className={cx(bt.btnPrimary, s.btnBlock, s.btnLarge)} onClick={handleClick}>
            <img src={searchIcon} className={cx(s.searchIconCommon, 'searchIconCommonTwoRTL')} />
            <span className={'hidden-xs'}>
              <FormattedMessage {...messages.search} />
            </span>
          </Button>
        </div>
      </div>
    </form>
  );
};

LocationSearchForm.propTypes = {
  settingsData: PropTypes.shape({
    listSettings: PropTypes.array.isRequired
  })
};

LocationSearchForm.defaultProps = {
  settingsData: {
    listSettings: []
  }
};

const ConnectedForm = reduxForm({
  form: 'SearchForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(LocationSearchForm);

export default withStyles(bt, s)(ConnectedForm);
